import { Controller } from "@hotwired/stimulus"

// Publishes the wrapper's measured height as `--app-banner-h` on documentElement
// so layout chrome (drawer panel, mobile fixed header) can offset itself by the
// total banner height. Re-measures on resize / DOM mutation.
export default class extends Controller {
  connect() {
    this.update = this.update.bind(this)
    this.update()
    if (typeof ResizeObserver !== "undefined") {
      this.observer = new ResizeObserver(this.update)
      this.observer.observe(this.element)
    }
    window.addEventListener("resize", this.update)
  }

  disconnect() {
    this.observer?.disconnect()
    window.removeEventListener("resize", this.update)
    document.documentElement.style.removeProperty("--app-banner-h")
  }

  update() {
    const h = this.element.offsetHeight || 0
    document.documentElement.style.setProperty("--app-banner-h", `${h}px`)
  }
}
